@if (primary.label === 'Check Eligibility') {
  <div [@showHide]="isHidden">
    <div class="footer-instruction" *transloco="let t; prefix: 'designSystem'">
      <span> {{ t('checkEligibilityDisclaimer') }}</span>
    </div>
  </div>
}
<div
  class="button-wrapper"
  [ngClass]="{
    loading: primLoading,
    disabled: primDisabled,
    valid: valid,
    'primary-bg': hasPrimaryBackground
  }"
  [@showHide]="isHidden"
  >
  <!-- SECONDARY BUTTON -->
  @if (secondary && secondary.label) {
    <button
      class="back-button secondary tucieloButtonContainer"
      (click)="secondaryAction()"
      [disabled]="secDisabled"
      [ngClass]="{ tucieloButton: tucieloButtonShow && !primDisabled }"
      >
      @if (secondary.arrow) {
        <span class="icon-container-left">
          <svg
            class="arrow arrow-left"
            width="23px"
            height="9px"
            viewBox="0 0 23 9"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            >
            <path d="M0.5,4.5 L22.5,4.5" stroke="#212121"></path>
            <polyline
              stroke="#212121"
              fill="transparent"
              transform="translate(4.510408, 4.545942) scale(-1, 1) rotate(45.000000) translate(-4.510408, -4.545942) "
              points="1.51040764 1.54594155 7.51040764 1.54594155 7.51040764 7.54594155"
            ></polyline>
          </svg>
        </span>
      }
      <span class="button-label ellipsis">{{ secondary.label }}</span>
      <div class="mat-ripple-receiver" matRipple></div>
    </button>
  }

  <!-- PRIMARY BUTTON -->
  <button
    class="button primary tucieloButtonContainer"
    (click)="primaryAction()"
    [class.centered-if-no-secondary]="primCenteredIfNoSecondary && !!secondary"
    [disabled]="primDisabled"
    [ngClass]="{ tucieloButton: tucieloButtonShow && !primDisabled }"
    >
    <span class="button-label ellipsis">{{ primary.label }}</span>

    @if (!primLoading && primary.arrow) {
      <span class="icon-container-right">
        <svg
          class="arrow arrow-right"
          width="23px"
          height="9px"
          viewBox="0 0 23 9"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          >
          <path d="M0.5,4.5 L22.5,4.5" stroke="#212121"></path>
          <polyline
            stroke="#212121"
            fill="transparent"
            transform="translate(18.510408, 4.545942) rotate(45.000000) translate(-18.510408, -4.545942)"
            points="15.5104076 1.54594155 21.5104076 1.54594155 21.5104076 7.54594155"
          ></polyline>
        </svg>
      </span>
    }

    @if (primLoading) {
      <span class="icon-container-right">
        <fa-icon [icon]="['fal', 'spinner-third']" class="spin-it"></fa-icon>
      </span>
    }

    <div class="mat-ripple-receiver" matRipple></div>
  </button>
</div>
